import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import QrCode from "../components/qrCode.jsx";
import Footer from "../components/footer.jsx";

function RecyclePage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <QrCode/> 
        </div>
        <Footer /> 
      </div>
      );
}
export default RecyclePage;
